import { render, staticRenderFns } from "./SubItemMasterBlock.vue?vue&type=template&id=76fc7ff0"
import script from "./SubItemMasterBlock.vue?vue&type=script&lang=js"
export * from "./SubItemMasterBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSpace,QSeparator} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpace,QSeparator})
